import React, { useRef, useState } from 'react';
import { SolutionExample } from './examples';
import styles from './styles.module.scss';

export default function ProductDemo({ example }: { example: SolutionExample }) {
  const [branchIndex, setBranchIndex] = useState<number | null>(null);
  const [answerIndex, setAnswerIndex] = useState<number | null>(null);
  const heading = useRef<HTMLHeadingElement>(null);
  const branch = branchIndex === null ? null : example.branches[branchIndex];
  const isResult = branch !== null && answerIndex !== null;
  const focusHeading = () => requestAnimationFrame(() => heading.current?.focus({ preventScroll: true }));

  return (
    <div className={styles.productPreview} aria-label="Interactive concept demo">
      <div className={styles.previewChrome}>
        <strong>Storycards</strong>
        <em>Concept demo</em>
      </div>
      <div className={styles.previewBody}>
        <span className={styles.previewLabel}>
          {isResult ? 'Your example result' : `Try it · Step ${branch ? '2' : '1'} of 2`}
        </span>
        <div className={styles.previewProgress} aria-hidden="true">
          <span style={{ width: isResult ? '100%' : branch ? '66%' : '33%' }} />
        </div>
        <h2 ref={heading} tabIndex={-1}>
          {isResult ? 'Here is a useful next step.' : branch?.question || example.question}
        </h2>
        {isResult && branch ? (
          <div className={styles.demoResult}>
            <span>
              {branch.label} / {branch.answers[answerIndex!]}
            </span>
            <p>{branch.results[answerIndex!]}</p>
            <div>
              <small>In a live journey</small>
              <strong>{branch.next}</strong>
            </div>
          </div>
        ) : (
          <div className={styles.previewOptions}>
            {(branch ? branch.answers : example.branches.map((item) => item.label)).map((label, index) => (
              <button
                type="button"
                key={label}
                onClick={() => {
                  if (branch) setAnswerIndex(index);
                  else setBranchIndex(index);
                  focusHeading();
                }}
              >
                <span>{String(index + 1).padStart(2, '0')}</span>
                <strong>{label}</strong>
                <span aria-hidden="true">→</span>
              </button>
            ))}
          </div>
        )}
        <div className={styles.demoFooter}>
          <p>Illustrative only. Your choices stay in this page.</p>
          {branch && (
            <button
              type="button"
              onClick={() => {
                setAnswerIndex(null);
                setBranchIndex(null);
                focusHeading();
              }}
            >
              Start again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
